// 상품 목록 api 파라미터 객체에서 값이 없는 키는 제외하는 함수 => 일반상품목록, ai상품목록 모두 사용
const getProductParams = (params: any) => {
  const _params = Object.entries(params)
    .filter((v: (string | any)[]) => {
      if (typeof v[1] === "object") return v[1].length > 0;
      if (v[0] === "file") return v[1] !== "data:," || !!v[1];
      return !!v[1];
    })
    .map((v) => {
      if (v[0] === "minPrice" || v[0] === "maxPrice") {
        return [v[0], Number(v[1])];
      }
      return v;
    });

  const newParams = Object.fromEntries(_params);

  return newParams;
};

export default getProductParams;
